import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { NotificationService } from '../../utils/notification.service';
import { AuthService } from '../../../+auth/auth.service';

declare var $: any;

@Component({
    selector: 'sa-logout',
    template: `
<div id="logout" (click)="showPopup()" class="btn-header transparent pull-right">
        <span> <a title="Sign Out" data-action="userLogout"
                  data-logout-msg="You can improve your security further after logging out by closing this opened browser"><i
          class="fas fa-sign-out-alt"></i></a> </span>
    </div>
  `,
    styles: []
})
export class LogoutComponent implements OnInit {

    constructor(
        private authService: AuthService,
        private notificationService: NotificationService) { }

    showPopup() {
        this.notificationService.smartMessageBox({
            title: "<i class='fa fa-sign-out txt-color-orangeDark'></i> Logout <span class='txt-color-orangeDark'><strong>" + $('#show-shortcut').text() + "</strong></span> ?",
            content: "You can improve your security further after logging out by closing this opened browser",
            buttons: '[No][Yes]'

        }, (ButtonPressed) => {
            if (ButtonPressed == "Yes") {
                this.logout()
            }
        });
    }

    logout() {
        console.log('>>calling authservice logout');
        // this.authService.logout();
        this.authService.trackLoginLogout().subscribe(() => {
            this.authService.logout();
        });
        console.log('<<calling authservice logout');
    }

    ngOnInit() {

    }
}



// WEBPACK FOOTER //
// ./src/app/shared/user/logout/logout.component.ts